import { FunctionComponent, memo } from 'react';
import { StoryCardPdfContent } from '../../../services';
import { FeedCardContentCommon, FeedCardPdfCommon, FeedCardProps } from '../../../shared';

export const FeedCardAdminPdf: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const {
    storyId,
    id,
    type,
    content,
    isPinnedToTopOfNewsFeed,
    isPinnedToTopOfStory,
    mentionedUsers,
  } = card;

  const { sourceName, headline, subHeadline, text, textHTML } = content as StoryCardPdfContent;

  return (
    <FeedCardContentCommon
      type={type}
      isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
      isPinnedToTopOfStory={isPinnedToTopOfStory}
      storyId={storyId}
      cardId={id}
      source={sourceName}
      title={headline}
      media={<FeedCardPdfCommon card={card} />}
      subTitle={subHeadline}
      text={text}
      htmlText={textHTML}
      mentionedUsers={mentionedUsers}
    />
  );
});
